import { render, staticRenderFns } from "./FlowCategoryModal.vue?vue&type=template&id=a8c1baf4"
import script from "./FlowCategoryModal.vue?vue&type=script&lang=js"
export * from "./FlowCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports